export default "__VITE_ASSET__C5RsFF4G__"